import React from 'react';

export default function ClientSearch({setInput, ...props}) {
  const onInputChange = (e) => {setInput(e.target.value)}
  return (
    <section className="client-search">
      <div className="form-group">
        <input
          type="text"
          placeholder="Search"
          className="form-control"
          onChange={onInputChange}
        />
        <span>
          <i className="fas fa-search"></i>
        </span>
      </div>
    </section>
  );
}
